module.exports = __webpack_public_path__ + "img/UT0409.3af51845.png";